import styled from '@emotion/styled';

export const StyledArticleWrapper = styled.div(({ theme: { space } }) => ({
    position: 'relative',
    display: 'flex',
    gap: space[5],
    paddingBottom: space[8],
}));
